import React from "react";
import { ArrowUpDown, CheckCircle2, ClipboardList, Filter, LayoutGrid, Swords, XCircle } from "lucide-react";
import { P2P_FILTER_ICONS } from "../../app/utils/sidebarNavIcons";
import AdminFiltersRail, {
  AdminFilterSection,
  AdminNavFilterItem,
} from "../components/AdminFiltersRail";
import { ADMIN_P2P_SORT_ICONS } from "../utils/adminDeskIcons";
import { P2P_DESK_VIEWS, P2P_SORT_OPTIONS, P2P_STATUS_FILTERS } from "./constants";

const DESK_ICONS = {
  all: LayoutGrid,
  active: Swords,
  needs_outcome: ClipboardList,
  settled: CheckCircle2,
  voided: XCircle,
};

export default function AdminP2PFiltersRail({
  desk,
  status,
  sortKey,
  summary,
  resultCount,
  onDeskChange,
  onStatusChange,
  onSortChange,
  onClear,
  activeCount,
  compact,
  onClose,
}) {
  const statusCounts = {
    All: summary?.total ?? 0,
    Active: summary?.active ?? 0,
    Pending: summary?.pending ?? 0,
    Settled: summary?.settled ?? 0,
    Voided: summary?.voided ?? 0,
  };

  const summaryCopy = [
    resultCount != null ? `${resultCount} duel${resultCount === 1 ? "" : "s"} in view` : null,
    activeCount ? `${activeCount} filter${activeCount === 1 ? "" : "s"} on` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <AdminFiltersRail
      title="P2P desk"
      subtitle="Duels · outcomes · ledger"
      deskIcon={Swords}
      compact={compact}
      onClose={onClose}
      activeCount={activeCount}
      onClear={onClear}
      summaryCount={resultCount ?? summary?.total}
      summaryCopy={summaryCopy || undefined}
    >
      <AdminFilterSection label="Desk">
        {P2P_DESK_VIEWS.map((v) => (
          <AdminNavFilterItem
            key={v.id}
            active={desk === v.id}
            onClick={() => onDeskChange(v.id)}
            icon={DESK_ICONS[v.id]}
            label={v.label}
            hint={v.hint}
            count={v.id === "needs_outcome" ? summary?.needsOutcome : null}
            countTone={v.id === "needs_outcome" && summary?.needsOutcome ? "warn" : undefined}
            urgent={v.id === "needs_outcome" && summary?.needsOutcome > 0}
          />
        ))}
      </AdminFilterSection>

      <AdminFilterSection label="Sort" labelIcon={ArrowUpDown}>
        {P2P_SORT_OPTIONS.map((opt) => (
          <AdminNavFilterItem
            key={opt.value}
            active={sortKey === opt.value}
            onClick={() => onSortChange(opt.value)}
            icon={ADMIN_P2P_SORT_ICONS[opt.value]}
            label={opt.label}
          />
        ))}
      </AdminFilterSection>

      <AdminFilterSection label="Status" labelIcon={Filter}>
        {P2P_STATUS_FILTERS.map((f) => (
          <AdminNavFilterItem
            key={f.value}
            active={status === f.value}
            onClick={() => onStatusChange(f.value)}
            icon={P2P_FILTER_ICONS[f.value]}
            label={f.label}
            count={statusCounts[f.value]}
          />
        ))}
      </AdminFilterSection>
    </AdminFiltersRail>
  );
}
